import api from "../api";
import { GET_ERRORS, GET_INSTITUTIONS, GET_INSTITUTION, GET_MEMBERINSTITUTION, DELETE_INSTITUTION } from "./types";

export const createInstitution = (institution, history) => async dispatch => {
  try {
    await api.post("/api/institutions", institution);
    history.push("/institution-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    });
  }
};

export const updateInstitution = (institution, history) => async dispatch => {
  try {
    await api.put(`/api/institutions/${institution.id}`, institution);
    history.push("/institution-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    });
  }
};

export const getInstitutions = () => async dispatch => {
  const res = await api.get("/api/institutions");
  if (window.location.pathname.includes("new-member")) {
    res.data.unshift({
      "id": 99999999,
      "institutionName": "Enter company name manually if it doesn`t exist below...",
      "address": "",
      "phone": "",
      "email": null,
      "sector": {
        "id": 99999999,
        "sectorCode": "",
        "sectorName": "",
        "tradeUnion": {
          "id": 1,
          "tuName": "",
          "abbreviation": "",
          "address": "",
          "phone": "",
          "logo": null,
          "tuPercentage": 99999999,
          "baseCurrency": ""
        }
      },
      "tuPercentage": null,
      "branch": {
        "id": 99999999,
        "branchName": "",
        "branchAddress": "",
        "email": "",
        "branchPhone": "",
        "branchTown": "",
        "tradeUnion": {
          "id": 1,
          "tuName": "",
          "abbreviation": "",
          "address": "",
          "phone": "",
          "logo": null,
          "tuPercentage": 99999999,
          "baseCurrency": ""
        }
      },
      "currency": ""
    });
  }
  dispatch({
    type: GET_INSTITUTIONS,
    payload: res.data
  });
  dispatch({
    type: GET_ERRORS,
    payload: {}
  });

};

export const getInstitution = (id, history) => async dispatch => {
  try {
    const res = await api.get(`/api/institutions/${id}`);

    dispatch({
      type: GET_INSTITUTION,
      payload: res.data
    });
  } catch (error) {

    history.push("/home");
  }
};


export const getMembers = (id, history) => async dispatch => {
  try {
    const res = await api.get(`/api/institutions/members/${id}`);

    dispatch({
      type: GET_MEMBERINSTITUTION,
      payload: res.data
    });
  } catch (error) {

    history.push("/home");
  }
};


export const deleteInstitution = id => async dispatch => {
  if (
    window.confirm(
      "Are you sure? This will delete the institution and all the data related to it"
    )
  ) {
    await api.delete(`/api/institutions/${id}`);
    dispatch({
      type: DELETE_INSTITUTION,
      payload: id
    });
  }
};


export const downloadSO = (institutionId, startDate, endDate) => {
  try {

    api(`/api/download-so-schedule/${institutionId}/${startDate}/${endDate}`, {
      method: 'GET',
      responseType: 'blob' //Force to receive data in a Blob Format
    })
      .then(response => {
        //Create a Blob from the PDF Stream
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window

        window.open(fileURL);
      })
  } catch (err) {
    console.log(err.payload)
  }
};


export const downloadEmployerSO = (institutionId, startDate, endDate) => {
  try {

    api(`/api/download-trade-union-report/${institutionId}/${startDate}/${endDate}`, {
      method: 'GET',
      responseType: 'blob' //Force to receive data in a Blob Format
    })
      .then(response => {
        //Create a Blob from the PDF Stream
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window

        window.open(fileURL);
      })
  } catch (err) {
    console.log(err.payload)
  }
};

export const downloadMembers = (institutionId) => {
  try {

    api(`/api/download-by-institution/${institutionId}`, {
      method: 'GET',
      responseType: 'blob' //Force to receive data in a Blob Format
    })
      .then(response => {
        //Create a Blob from the PDF Stream
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window

        window.open(fileURL);
      })
  } catch (err) {
    console.log(err.payload)
  }
};

export const downloadInvoice = (institutionId) => {
  try {

    api(`/api/print-invoice/${institutionId}`, {
      method: 'GET',
      responseType: 'blob' //Force to receive data in a Blob Format
    })
      .then(response => {
        //Create a Blob from the PDF Stream
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window

        window.open(fileURL);
      })
  } catch (err) {
    console.log(err.payload)
  }
};

export const downloadArrears = (institutionId) => {
  try {

    api(`/accounts/arrears-by-institution/${institutionId}`, {
      method: 'GET',
      responseType: 'blob' //Force to receive data in a Blob Format
    })
      .then(response => {
        //Create a Blob from the PDF Stream
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window

        window.open(fileURL);
      })
  } catch (err) {
    console.log(err.payload)
  }
};